
import { defineComponent } from "vue";

export default defineComponent({
  name: "SuccessItem",
  props: {
    caption: String,
  },
});
